// extracted by mini-css-extract-plugin
export default {"nameFields":"ShortForm_nameFields__SRgCI"};